import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatRipple} from '@angular/material/core';
import {NgClass, NgStyle} from '@angular/common';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-button-w-loader',
  imports: [
    MatProgressSpinner,
    MatRipple,
    NgClass,
    MatIcon,
    NgStyle
  ],
  templateUrl: './button-w-loader.component.html',
  standalone: true,
  styleUrl: './button-w-loader.component.scss'
})
export class ButtonWLoaderComponent {

  @Output() buttonClick = new EventEmitter();
  @Input() loading = false;
  @Input() disabled = false;
  @Input() type: 'primary' | 'yellow' | 'outline' | 'outline-purple' | 'secundary-white' = 'primary';
  @Input() label!: string;
  @Input() sufixIcon?: string;
  @Input() prefixIcon?: string;
  @Input() padding?: string =  '6px 16px';


  _click(){
    if(!this.loading && !this.disabled){
      this.buttonClick.emit();
    }
  }

}
